export default function({ store, redirect, route }) {
  if (!store.state.token) {
    return redirect('/2af3RT5Op1vb-7Weos385-TY94')
  }
}
